import { H2 } from 'shared/components/title';
import { View } from 'react-native';
import { breederReviews, buyerReviews } from 'shared/library/reviews';
import { ReviewCard } from 'shared/components/review-card';
import { ReviewsSummaryCard } from 'shared/components/reviews-summary-card';
import { useTranslation } from 'react-i18next';
import { Role } from 'shared/@types';

export const ReviewsSegment = ({ role }: { role: Role }) => {
  const { t } = useTranslation('components');

  const reviews = role === 'seller' ? breederReviews : buyerReviews;

  const title =
    role === 'seller'
      ? t('reviews_segment.trusted_by_breeders')
      : t('reviews_segment.trusted_by_pet_owners');

  const description =
    role === 'seller'
      ? t('reviews_segment.trusted_by_breeders_description')
      : t('reviews_segment.trusted_by_pet_owners_description');

  return (
    <>
      <H2 title={title} subtitle={description} center={true} />

      <View className={'mx-auto mt-3 w-full max-w-screen-md gap-3 md:gap-6'}>
        {reviews.map((review, index) => (
          <ReviewCard review={review} key={index} />
        ))}
      </View>

      <ReviewsSummaryCard className={'mt-6'} />
    </>
  );
};
